/**
 * Timeline
 */

 var component_timeline = function() {

  // setup args
  const timeline = document.querySelectorAll('timeline');

  const slides = document.querySelectorAll('.swiper-slide');
  const years = [];

  slides.forEach((item) => {
    if( item.getAttribute('data-year') ) {
      years.push(item.getAttribute('data-year'));
    }
  });

  // validate
  if (!timeline) {
    console.log('no timeline element suplied');
    return;
  }


  /**
   * Init
   */
  function init_component_timeline() {

    const swiper = new Swiper('.swiper', {

      // optional parameters
      direction: 'horizontal',
      loop: true,

      // vavigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      // button screen reader text
      a11y: {
        prevSlideMessage: theme_strings.next,
        nextSlideMessage: theme_strings.prev,
      },

      // pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          return '<div class="' + className + '"><span class="' + className + '__bullet"></span><span class="' + className + '__year">' + years[index] + "</span></div>";
        },
      },
    });

    return;
  }
  init_component_timeline();

  // make the call chainable
  return this;
};
